// extracted by mini-css-extract-plugin
export default {"icon":"icon__ZJIBl","__right":"__right__bM883"};